import styled from 'styled-components';

import { TileContainer } from '~src/styles/containers.sc';
import { media } from '~src/styles/media-templates';

export const UserFormContainer = styled(TileContainer)`
  margin-top: 30px;
  margin-bottom: 30px;
`;

export const InfoSortingBlock = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
`;

export const FilterSortCol = styled.div`
  display: flex;
  justify-content: flex-end;
  ${media.phone`
    min-width: 100%;
  `}
`;

export const FilterFilterCol = styled(FilterSortCol)`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  padding-top: 30px;
  flex-wrap: wrap;
  > div {
    margin-left: 30px;
  }
`;

export const SearchWrapper = styled.div`
  margin-right: 30px;
  width: 178px;
`;

export const DeactivatedWrapper = styled.div`
  margin-right: 30px;
  width: 195px;
  display: flex;
`;
